import { FC, InputHTMLAttributes } from 'react';
import getTestId from '@functions/testId';
import Label from '@components/InputLabel/InputLabel';

type Props = {
    testId?: string;
    label?: string;
    register?: any | null; //eslint-disable-line
    serverRendered?: boolean;
};

const TextField: FC<Props & InputHTMLAttributes<HTMLInputElement>> = ({
    register,
    testId = null,
    label,
    serverRendered = false,
    ...props
}) => {
    return (
        <div className="text-field tw-flex tw-w-full tw-flex-col tw-items-start tw-justify-start">
            <Label testId={`${testId}-label`} htmlFor={register && register.name ? register.name : props.name}>
                {label}
            </Label>
            <input
                {...props}
                className={
                    'tw-grey-900 tw-h-12 tw-w-full tw-rounded tw-border tw-border-grey-600 tw-bg-white tw-px-3 tw-text-sm tw-leading-[18px] placeholder:tw-text-grey-500 hover:tw-border-navy-600 focus:tw-border-navy-600 focus:tw-shadow-[0_0_0_1px_#06556e] focus:tw-outline-0 active:tw-border-navy-600'
                }
                data-testid={getTestId(testId, serverRendered)}
                {...register}
            />
        </div>
    );
};

export default TextField;
